import path from 'path';

import { OffsetPagedResults } from '~interfaces';
import { BasePagedParameters } from '~interfaces/requests';
import { BaseReferenceResponse, PagedResponse } from '~interfaces/responses';
import { TopologyService } from '~services';

import TransactionSummary from '../interfaces/transactionSummary';

class TransactionsService extends TopologyService {
	public readonly path = 'transactions/summary';

	constructor() {
		super('v1');
	}

	/**
	 * Get a list of access rules
	 * @param date As date object or date iso string
	 * TODO: date should eventually be of type Date, but for backwards compatibility
	 * allow a string.
	 * @returns
	 */
	async getTransactionsSummary(
		args: BasePagedParameters & {
			providerId?: string;
			searchQuery?: string;
		}
	): Promise<OffsetPagedResults<TransactionSummary>> {
		const { data } = await this._client.get<PagedResponse<TransactionSummaryResponse>>(this.path, {
			params: {
				pageNumber: args.page,
				pageSize: args.pageSize,
				providerId: args.providerId,
				searchTerm: args.searchQuery,
			},
		});

		return this.mapPagedResponse(data, (el) => TransactionsService.fromResponse(el));
	}

	/**
	 * Get a list of access rules
	 * @param date As date object or date iso string
	 * TODO: date should eventually be of type Date, but for backwards compatibility
	 * allow a string.
	 * @returns
	 */
	async getTransactionsSummaryByDate(
		date: Date,
		args: BasePagedParameters & {
			providerId?: string;
			searchQuery?: string;
		}
	): Promise<TransactionSummary[]> {
		const { data } = await this._client.get<TransactionSummaryResponse[]>(
			path.join(this.path, date.toISOString()),
			{
				params: {
					providerId: args.providerId,
					searchTerm: args.searchQuery,
				},
			}
		);

		return data.map((el) => TransactionsService.fromResponse(el));
	}

	/**
	 * TODO: don't mapping for now, because we use this service mainly for "legacy" code.
	 * Eventually do proper mapping to seperate business and api data
	 * @param data
	 * @returns
	 */
	static fromResponse(data: TransactionSummaryResponse): TransactionSummary {
		const { start, end, organisation, ...rest } = data;

		return {
			...rest,
			organisation: TransactionsService.fromBaseReferenceResponse(organisation),
			start: new Date(start),
			end: new Date(start),
		};
	}
}

interface TransactionSummaryResponse {
	organisation: BaseReferenceResponse;
	start: string;
	end: string;
	total: number;
	count: number;
	paymentMethods: PaymentMethodTransactionSummaryResponse[];
}

interface PaymentMethodTransactionSummaryResponse {
	total: number;
	count: number;
	paymentMethod: string;
}

export default TransactionsService;
